import { AxiosResponse } from "axios";
import API from "../api";
import { PdfReport } from "../models/pdf.report";
import { ShipmentDocument } from "../models/shipment.document";

const endpoint = "shipments/reports";

const ShipmentReportService = {
  async generateInvoicePDF(shipmentId: number): Promise<AxiosResponse<PdfReport>> {
    return await API.post(`/${endpoint}/invoice`, { shipmentId });
  },

  async generatePackingPDF(shipmentId: number): Promise<AxiosResponse<PdfReport>> {
    return await API.post(`/${endpoint}/packing`, { shipmentId });
  },

  async generateInvoicePackingPDFs(shipmentId: number): Promise<AxiosResponse<PdfReport>> {
    return await API.post(`/${endpoint}/booking/pdf/cipl`, { shipmentId });
  },

  async generateCiplCSV(shipmentId: number): Promise<AxiosResponse<PdfReport>> {
    return await API.post(`/${endpoint}/booking/csv/cipl`, { shipmentId });
  },

  async generateAllDocumentsZip(
    shipmentId: number,
    documents?: ShipmentDocument[],
    hasBookingId?: boolean
  ): Promise<AxiosResponse<any>> {
    return await API.post(`/${endpoint}/booking/zip`, { shipmentId, documents, hasBookingId });
  },
};

export default ShipmentReportService;
